module.exports = __webpack_public_path__ + "static/media/4.01a61e83.jpg";